<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    scrollable
    transition="dialog-bottom-transition"
    class="AssignmentReportDialog"
    @input="$emit('input', $event)"
  >
    <v-card v-if="report" tile>
      <v-app-bar style="z-index: 1" max-height="64">
        <v-btn
          icon
          @click="close"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Report preview</v-toolbar-title>
        <v-spacer />
        <v-chip dark :color="report.success ? 'green' : 'red'">
          {{ report.success ? 'Passed' : 'Failed' }} with {{ report.grade }}%
        </v-chip>
      </v-app-bar>

      <v-card-text class="pa-0 px-sm-6 pb-sm-5">
        <v-container>
          <AssignmentReportTasks
            :assignment-id="assignment._id"
            :tasks="assignment.content"
            :report="report"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AssignmentReportDialog',
  components: {
    AssignmentReportTasks: () => import('@/components/assignments/AssignmentReportTasks'),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    assignmentId: {
      type: String,
      default: null,
    },
    reportId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('assignments', [
      'assignments',
    ]),
    assignment() {
      return this.assignments.find(a => a._id === this.assignmentId);
    },
    report() {
      return this.assignment?.reports?.find(r => r._id === this.reportId);
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>
